export default "__VITE_ASSET__O$$IrRim__"